import React, { FC } from 'react';
import { Stack } from '@mui/material';
import styles from './HomePage.module.scss';
import HeaderComponent from '../HeaderComponent/HeaderComponent';
import ScanComponent from '../ScanComponent/ScanComponent';
import MenuComponent from '../MenuComponent/MenuComponent';

interface HomePageProps {
    hasSizeMatch: boolean;
    hasMeasurements: boolean;
    hasWellness: boolean;
    hasBodyComposition: boolean;
    frontProfileImageUrl: string | null;
    sideProfileImageUrl: string | null;
}

const HomePage: FC<HomePageProps> = (props) => {
    const {
        hasSizeMatch,
        hasMeasurements,
        hasWellness,
        hasBodyComposition,
        frontProfileImageUrl,
        sideProfileImageUrl,
    } = props;

    return (
        <div className={styles.HomePage} data-testid="HomePage">
            <HeaderComponent />
            <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={4}
                sx={{ py: 4, px: 3 }}
            >
                <ScanComponent
                    frontProfileImageUrl={frontProfileImageUrl}
                    sideProfileImageUrl={sideProfileImageUrl}
                />
                <MenuComponent
                    hasSizeMatch={hasSizeMatch}
                    hasMeasurements={hasMeasurements}
                    hasWellness={hasWellness}
                    hasBodyComposition={hasBodyComposition}
                />
            </Stack>
        </div>
    );
};

export default HomePage;
